import {
  Stack,
  type SxProps,
  Tooltip,
  Typography,
  type Theme,
} from "@mui/material";
import React from "react";

import WarningIconComponent from "./icons/warningIcon";

import type { Variant } from "@mui/material/styles/createTypography";
import type { TypographyPropsVariantOverrides } from "@mui/material/Typography";
import type { OverridableStringUnion } from "@mui/types";

const Flag: React.FC<{
  flag?: boolean | null;
  flagTooltip?: string | null;
  textTooltip?: string | null;
  name?: string | null;
  sx?: SxProps<Theme>;
  node?: React.ReactNode;
  icon?: React.ReactNode;
  variant?:
    | OverridableStringUnion<
        Variant | "inherit",
        TypographyPropsVariantOverrides
      >
    | undefined;
}> = ({ flag, flagTooltip, textTooltip, name, sx, node, variant,icon }) => (
  <Stack direction="row" alignItems="center" spacing={0.5}>
    {flag &&
      (icon ? (
        <span title={flagTooltip ?? undefined}>{icon}</span>
      ) : (
        <WarningIconComponent title={flagTooltip} />
      ))}
    {name ? (
      <Tooltip
        title={textTooltip}
        placement="bottom"
        arrow
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -8],
                },
              },
            ],
          },
        }}
      >
        <Typography variant={variant || "body2"} noWrap sx={sx}>
          {name}
        </Typography>
      </Tooltip>
    ) : (
      node
    )}
  </Stack>
);

export default Flag;
